module.exports = __webpack_public_path__ + "img/com.electrolux.connectapp.lavaeseca.60ceb742.webp";